import { render, staticRenderFns } from "./ReviewQualityControlDetail.vue?vue&type=template&id=4b3fd367&scoped=true"
import script from "./ReviewQualityControlDetail.vue?vue&type=script&lang=js"
export * from "./ReviewQualityControlDetail.vue?vue&type=script&lang=js"
import style0 from "./ReviewQualityControlDetail.vue?vue&type=style&index=0&id=4b3fd367&prod&scoped=true&lang=css"
import style1 from "./ReviewQualityControlDetail.vue?vue&type=style&index=1&id=4b3fd367&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3fd367",
  null
  
)

export default component.exports